module.exports = __webpack_public_path__ + "img/gray-blue-transition-clean.415bdb3c.png";